// Auto-register all media resources globally
// Import this ONCE in your app's entry point (index.jsx or App.jsx)

import { 
  registerMicrophoneStream, 
  registerAudioContext, 
  registerMediaStreamSource 
} from './microphonePermissionManager';

let interceptorsInstalled = false;

export const installMediaInterceptors = () => {
  if (interceptorsInstalled) return;
  interceptorsInstalled = true;

  // 1. Intercept getUserMedia
  const originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function(...args) {
    return originalGetUserMedia(...args).then(stream => {
      registerMicrophoneStream(stream);
      return stream;
    });
  };

  // 2. Intercept AudioContext
  const OriginalAudioContext = window.AudioContext || window.webkitAudioContext;
  const AudioContextProxy = new Proxy(OriginalAudioContext, {
    construct(target, args) {
      const instance = new target(...args);
      registerAudioContext(instance);
      
      // Intercept createMediaStreamSource
      const originalCreateSource = instance.createMediaStreamSource.bind(instance);
      instance.createMediaStreamSource = function(stream) {
        const source = originalCreateSource(stream);
        registerMediaStreamSource(source);
        return source;
      };
      
      return instance;
    }
  });

  window.AudioContext = AudioContextProxy;
  if (window.webkitAudioContext) {
    window.webkitAudioContext = AudioContextProxy;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('🎤 Media API interceptors installed');
  }
};
